module.exports = __webpack_public_path__ + "img/enter_mono.5e88848b.png";